import React from 'react';

import './StatusSelect.scss';
import { apiInstance, ParticipantInfo } from '@api';
import { ChipsSelect } from '@components';

interface StatusSelectProps {
	onChange?: (values: ParticipantInfo[]) => void,
	values: ParticipantInfo[],
	suggestedValues: ParticipantInfo[],
	name?: string,
	className?: string,
	disabled?: boolean,
}

function StatusSelect(props: StatusSelectProps): JSX.Element {
	const {
		className,
		disabled,
		onChange,
		values,
		name,
		suggestedValues,
	} = props;

	return <ChipsSelect
				className={className}
				disabled={disabled}
				onChange={onChange}
				values={values}
				suggestedValues={suggestedValues}
				name={name}
				processQuery={(query, maxResults) => apiInstance.queryParticipant(query, maxResults)} 
				queryDisabled={true}
				valueIdAttribute="code"
			/>;
}

const MemoisedStatusSelect = React.memo(StatusSelect);

export {MemoisedStatusSelect as StatusSelect};